/* =============================================================
   AMIGOS TÓXICOS — theme behaviour
   One file, plain ES5-ish, no framework, no build step.
   Blocks: age gate · sticky header · reveals · mobile menu · cart drawer
   · popups (newsletter / wholesale) · subscribe API · product page ·
   store locator (Leaflet) · theme-editor hooks.
   ============================================================= */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function money(cents) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100);
  }
  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }

  /* ---------------- age gate ---------------- */
  function initGate() {
    var gate = $('#gate');
    if (!gate) return;
    if (designMode || ss('at_age') === '1') { gate.hidden = true; return; }
    document.body.style.overflow = 'hidden';
    var yes = $('#gateYes');
    yes && yes.addEventListener('click', function () {
      gate.hidden = true;
      document.body.style.overflow = '';
      ss('at_age', '1');
    });
  }

  /* ---------------- sticky header ---------------- */
  function initHeader() {
    var hdr = $('#hdr');
    if (!hdr) return;
    var onScroll = function () { hdr.classList.toggle('is-stuck', window.scrollY > 12); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------------- reveals ---------------- */
  function initReveals(root) {
    var els = $$('.rv', root);
    if (designMode || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------------- mobile menu ---------------- */
  function initMobnav() {
    var burger = $('#burger'), nav = $('#mobnav');
    if (!burger || !nav) return;
    function setOpen(open) {
      nav.hidden = !open;
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    }
    burger.addEventListener('click', function () { setOpen(nav.hidden); });
    nav.addEventListener('click', function (e) { if (e.target.tagName === 'A') setOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !nav.hidden) setOpen(false); });
    window.addEventListener('resize', function () { if (window.innerWidth > 860 && !nav.hidden) setOpen(false); });
  }

  /* ---------------- cart drawer ---------------- */
  var Cart = {
    ov: null, el: null, state: null,
    init: function () {
      this.ov = $('#cartov'); this.el = $('#cart');
      var self = this;
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-open-cart]')) { e.preventDefault(); self.open(); }
        else if (e.target.closest('[data-close-cart]')) { self.close(); }
        var dec = e.target.closest('[data-dec]'), inc = e.target.closest('[data-inc]'), rm = e.target.closest('[data-rm]');
        if (dec) self.change(dec.getAttribute('data-dec'), -1);
        if (inc) self.change(inc.getAttribute('data-inc'), 1);
        if (rm)  self.set(rm.getAttribute('data-rm'), 0);
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });
      this.fetch();
    },
    open: function () {
      if (!this.el) return;
      this.ov.classList.add('is-open'); this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      this.fetch();
    },
    close: function () {
      if (!this.el) return;
      this.ov.classList.remove('is-open'); this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },
    fetch: function () {
      var self = this;
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
        .then(function (d) { self.state = d; self.render(); }).catch(function () {});
    },
    add: function (id, qty) {
      var self = this;
      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty || 1 })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'add failed'); });
        return self.fetch();
      });
    },
    change: function (key, delta) {
      var line = this.state && this.state.items.filter(function (l) { return l.key === key; })[0];
      if (!line) return;
      this.set(key, Math.max(0, line.quantity + delta));
    },
    set: function (key, qty) {
      var self = this;
      var msg = $('#cartMsg'); if (msg) msg.textContent = '';
      fetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (j) {
          // Shopify caps the line at stock and explains why in `description`
          if (msg && (j.description || j.message)) msg.textContent = j.description || j.message;
          return self.fetch();
        });
    },
    render: function () {
      var d = this.state; if (!d) return;
      $$('[data-cart-count]').forEach(function (b) { b.textContent = d.item_count; b.classList.toggle('is-on', d.item_count > 0); });
      var lines = $('#cartLines'), empty = $('#cartEmpty'), foot = $('#cartFoot'), sub = $('#cartSubtotal');
      if (!lines) return;
      if (!d.items.length) { lines.innerHTML = ''; empty.hidden = false; foot.hidden = true; return; }
      empty.hidden = true; foot.hidden = false;
      sub.textContent = money(d.total_price);
      lines.innerHTML = d.items.map(function (it) {
        var v = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; })
                 .map(function (o) { return esc(o.value); }).join(' · ');
        var img = it.featured_image && it.featured_image.url ? it.featured_image.url.replace(/(\.[a-z]+)(\?.*)?$/i, '_200x$1') : '';
        return '<div class="cart__line">' +
          '<a class="cart__img" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(it.product_title) + '" width="84" height="84">' : '') + '</a>' +
          '<div><p class="cart__name"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></p>' +
          (v ? '<p class="cart__var">' + v + '</p>' : '') +
          '<p class="cart__price">' + money(it.final_line_price) + '</p>' +
          '<div class="cart__qty">' +
            '<button class="cart__qbtn" type="button" data-dec="' + esc(it.key) + '" aria-label="Decrease">−</button>' +
            '<span class="cart__qval">' + it.quantity + '</span>' +
            '<button class="cart__qbtn" type="button" data-inc="' + esc(it.key) + '" aria-label="Increase">+</button>' +
            '<button class="cart__rm" type="button" data-rm="' + esc(it.key) + '">remove</button>' +
          '</div></div></div>';
      }).join('');
    }
  };

  /* ---------------- popups ---------------- */
  function openPop(el) { if (!el) return; el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closePop(el) { if (!el) return; el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  function initPopups() {
    document.addEventListener('click', function (e) {
      var closer = e.target.closest('[data-close-pop]');
      if (closer) { closePop(closer.closest('.pop')); return; }
      if (e.target.classList && e.target.classList.contains('pop')) { closePop(e.target); return; }
      if (e.target.closest('[data-open-wholesale]')) { e.preventDefault(); openPop($('#wholesale')); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') $$('.pop.is-open').forEach(closePop); });

    // "copy address" — for desktops with no mail client, where a mailto: does nothing
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-copy]'); if (!btn) return;
      var text = btn.getAttribute('data-copy'), label = btn.textContent;
      function done(ok) { btn.textContent = ok ? 'copied ✓' : 'select and copy: ' + text; setTimeout(function () { btn.textContent = label; }, 2200); }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(function () { done(true); }, function () { done(false); });
      else done(false);
    });
  }

  /* ---------------- newsletter ---------------- */
  var DISMISS_KEY = 'newsletter:lastDismissedAt', SUBSCRIBED_KEY = 'newsletter:subscribed';
  var COOLDOWN_MS = 7 * 24 * 60 * 60 * 1000;
  var DEFAULT_API = 'https://amigos-toxicos.vercel.app/api/newsletter-subscribe';

  function phoneMask(el) {
    if (!el) return;
    el.addEventListener('input', function () {
      var d = el.value.replace(/\D/g, '').slice(0, 10), out = d;
      if (d.length > 6) out = '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6);
      else if (d.length > 3) out = '(' + d.slice(0, 3) + ') ' + d.slice(3);
      else if (d.length > 0) out = '(' + d;
      el.value = out;
    });
  }

  // Same contract as the previous theme: the API normalises the phone to
  // E.164, creates the customer and sets marketing consent. Returns {ok}.
  function subscribe(api, payload) {
    return fetch(api || DEFAULT_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok || !data.ok) throw new Error(data.message || 'Something went wrong. Please try again.');
        return data;
      });
    });
  }
  function birthday(m, d, y) {
    m = (m || '').trim(); d = (d || '').trim(); y = (y || '').trim();
    if (!m || !d || !y) return '';
    return y + '-' + ('0' + m).slice(-2) + '-' + ('0' + d).slice(-2);
  }

  function initNewsletter() {
    var pop = $('#newsletter'); if (!pop) return;
    var steps = {};
    $$('.pop__step', pop).forEach(function (s) { steps[s.getAttribute('data-step')] = s; });
    function show(name) { Object.keys(steps).forEach(function (k) { steps[k].hidden = k !== name; }); }

    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-nl-yes]')) show('form');
      if (e.target.closest('[data-nl-back]')) show('prompt');
      if (e.target.closest('[data-close-pop]') || e.target === pop) ls(DISMISS_KEY, String(Date.now()));
    });

    // timed prompt
    var enabled = pop.getAttribute('data-enabled') === 'true';
    var delay = parseInt(pop.getAttribute('data-delay'), 10) || 7;
    var last = parseInt(ls(DISMISS_KEY) || '0', 10);
    if (enabled && !designMode && ls(SUBSCRIBED_KEY) !== 'true' && (Date.now() - last) > COOLDOWN_MS) {
      setTimeout(function () {
        if ($('#gate') && !$('#gate').hidden) {       // wait for the age gate
          var t = setInterval(function () { if ($('#gate').hidden) { clearInterval(t); show('prompt'); openPop(pop); } }, 500);
        } else { show('prompt'); openPop(pop); }
      }, delay * 1000);
    }

    // footer email → straight to the form step, pre-filled
    var ftr = $('#ftrForm');
    ftr && ftr.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = ftr.querySelector('input[type=email]').value.trim();
      var em = $('#nlEmail'); if (em) em.value = v;
      show('form'); openPop(pop);
      var first = $('#nlFirst'); first && first.focus();
    });

    var form = $('#nlForm'); if (!form) return;
    phoneMask($('#nlPhone'));
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var err = $('#nlErr'), btn = $('#nlSubmit');
      var first = $('#nlFirst').value.trim(), last_ = $('#nlLast').value.trim(), email = $('#nlEmail').value.trim();
      err.textContent = '';
      if (!first || !last_ || !email || !/^\S+@\S+\.\S+$/.test(email)) { err.textContent = 'Please add your first name, last name and a valid email.'; return; }
      btn.disabled = true; btn.textContent = 'one sec…';
      subscribe(form.getAttribute('data-subscribe-api'), {
        email: email, firstName: first, lastName: last_,
        phone: $('#nlPhone').value.trim(),
        birthday: birthday($('#nlBm').value, $('#nlBd').value, $('#nlBy').value),
        accountType: $('#nlType').value, source: 'site_popup'
      }).then(function () {
        ls(SUBSCRIBED_KEY, 'true'); show('done');
        setTimeout(function () { closePop(pop); }, 3000);
      }).catch(function (ex) {
        err.textContent = ex.message || 'Something went wrong. Please try again.';
      }).then(function () { btn.disabled = false; btn.textContent = 'subscribe'; });
    });
  }

  /* ---------------- register page ---------------- */
  function initRegister() {
    var form = $('#regForm'); if (!form) return;
    phoneMask($('#regPhone'));
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var err = $('#regErr'), btn = $('#regSubmit');
      var first = $('#regFirst').value.trim(), email = $('#regEmail').value.trim(), phone = $('#regPhone').value.replace(/\D/g, '');
      err.textContent = '';
      if (!first || !/^\S+@\S+\.\S+$/.test(email) || phone.length !== 10) { err.textContent = 'First name, a valid email and a 10-digit US phone are required.'; return; }
      btn.disabled = true; btn.textContent = 'one sec…';
      subscribe(form.getAttribute('data-subscribe-api'), {
        email: email, firstName: first, lastName: $('#regLast').value.trim(),
        phone: $('#regPhone').value.trim(),
        birthday: birthday($('#regBm').value, $('#regBd').value, $('#regBy').value),
        accountType: $('#regType').value, smsOptIn: !!$('#regSms').checked, source: 'site_register'
      }).then(function () {
        ls(SUBSCRIBED_KEY, 'true');
        form.hidden = true; var ok = $('#regOk'); ok.hidden = false; ok.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }).catch(function (ex) {
        err.textContent = ex.message || 'Something went wrong. Please try again.';
        btn.disabled = false; btn.textContent = 'join the club';
      });
    });
  }

  /* ---------------- product page ---------------- */
  function initProduct() {
    var form = $('#pdpForm'); if (!form) return;
    var jsonEl = $('#pdpJson'), product = null;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    // gallery
    var main = $('#pdpMain');
    $$('#pdpThumbs .pdp__thumb').forEach(function (t, i, all) {
      t.addEventListener('click', function () {
        if (!main) return;
        main.src = t.getAttribute('data-src'); main.srcset = t.getAttribute('data-srcset') || '';
        all.forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });

    // variant resolution from option pills
    var groups = $$('.sizes[data-option-index]', form);
    var idEl = $('#pdpVariant'), priceEl = $('#pdpPrice'), stockEl = $('#pdpStock'), addBtn = $('#addBtn');
    function selected() {
      return groups.map(function (g) { var on = g.querySelector('[aria-pressed="true"]'); return on ? on.getAttribute('data-value') : null; });
    }
    function findVariant(sel) {
      return product.variants.filter(function (v) {
        return sel.every(function (val, i) { return val == null || v.options[i] === val; });
      })[0];
    }
    function applyVariant(v) {
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'unavailable'; stockEl.textContent = 'that combination is not available'; stockEl.classList.add('pdp__stock--out'); return; }
      idEl.value = v.id;
      priceEl.innerHTML = (v.compare_at_price && v.compare_at_price > v.price ? '<s style="opacity:.5;margin-right:8px">' + money(v.compare_at_price) + '</s>' : '') + money(v.price);
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'add to bag' : 'sold out';
      stockEl.textContent = v.available ? 'in stock' : 'sold out in this size';
      stockEl.classList.toggle('pdp__stock--out', !v.available);
      if (v.featured_image && v.featured_image.src && main && !main.hasAttribute('data-cutout')) { main.src = v.featured_image.src; main.srcset = ''; }
      // mark pills whose variant is sold out
      groups.forEach(function (g, gi) {
        $$('.size', g).forEach(function (b) {
          var probe = selected(); probe[gi] = b.getAttribute('data-value');
          var pv = findVariant(probe);
          b.disabled = !pv || !pv.available;
          if (b.getAttribute('aria-pressed') === 'true') b.disabled = false;
        });
      });
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
    }
    groups.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('.size'); if (!b) return;
        $$('.size', g).forEach(function (o) { o.setAttribute('aria-pressed', 'false'); o.setAttribute('aria-checked', 'false'); });
        b.setAttribute('aria-pressed', 'true'); b.setAttribute('aria-checked', 'true');
        applyVariant(findVariant(selected()));
      });
    });
    if (groups.length) applyVariant(findVariant(selected()));

    // add to bag → drawer
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn.disabled) return;
      var orig = addBtn.textContent;
      addBtn.disabled = true; addBtn.textContent = 'adding…';
      Cart.add(idEl.value, 1).then(function () {
        addBtn.textContent = 'added ✓'; Cart.open();
      }).catch(function (ex) {
        addBtn.textContent = ex.message || 'could not add';
      }).then(function () {
        setTimeout(function () { addBtn.disabled = false; addBtn.textContent = orig; }, 1800);
      });
    });
  }

  /* ---------------- store locator ---------------- */
  // Live feed (our locations admin) → the same row shape the section blocks
  // produce, so the rest of the map code does not care where rows came from.
  function feedToRows(json) {
    var list = (json && json.locations) || [];
    return list.map(function (l) {
      var addr = [l.address_line_1, l.address_line_2].filter(Boolean).join(', ') + ', ' + l.city + ', ' + l.state + (l.postcode ? ' ' + l.postcode : '');
      return { id: 'f' + l.id, name: l.name, addr: addr, tel: l.phone || '', url: l.url || '', city: l.city, state: l.state, zip: l.postcode || '',
               type: l.kind === 'bar' ? 'drink' : 'buy', lat: Number(l.lat), lng: Number(l.lng) };
    });
  }

  function initLocator() {
    var dataEl = $('#locData'); if (!dataEl || !$('#locMap')) return;
    var feedUrl = dataEl.getAttribute('data-url');
    if (feedUrl && !initLocator.fetched) {
      initLocator.fetched = true;
      fetch(feedUrl, { mode: 'cors' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (j) { initLocator.feed = feedToRows(j); initLocator(); })
        .catch(function () { initLocator.feed = null; initLocator(); });   // fall back to the blocks
      return;
    }
    var mapEl = $('#locMap');
    var data = initLocator.feed;
    if (!data) { data = []; try { data = JSON.parse(dataEl.textContent); } catch (e) {} }
    var all = data.filter(function (s) { return isFinite(s.lat) && isFinite(s.lng) && s.lat !== 0; });
    // list A→Z by name (entry order put 47 Total Wines at the top — owner, 2026-09-16);
    // "use my location" re-sorts by distance on top of this
    all.sort(function (a, b) { return String(a.name).localeCompare(String(b.name), 'en', { sensitivity: 'base', numeric: true }); });
    var list = $('#locList'), count = $('#locCount'), empty = $('#locEmpty'), q = $('#locQ'), gpsBtn = $('#locGps');

    // Leaflet is loaded with defer from the section; wait for it briefly.
    if (typeof window.L === 'undefined') {
      var tries = 0;
      var t = setInterval(function () {
        if (typeof window.L !== 'undefined' || ++tries > 40) { clearInterval(t); if (typeof window.L !== 'undefined') initLocator(); else fallback(); }
      }, 100);
      return;
    }
    function fallback() {
      mapEl.style.display = 'none';
      $('#locator').style.gridTemplateColumns = '1fr';
      renderList(all);
    }

    var map = L.map(mapEl, { scrollWheelZoom: false }).setView([36.5, -119.5], 6);
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '&copy; OpenStreetMap contributors' }).addTo(map);

    // Pins are the lips mark (client's ask, 2026-09-16): red = store, tinted
    // green = bar / restaurant, mango = selected. A cluster is a bigger lips
    // with the count in a badge. The image URL is on the section (data-lips).
    var LIPS = dataEl.getAttribute('data-lips') || '';
    var PW = window.innerWidth <= 860 ? 48 : 40, PH = Math.round(PW * 0.56);   // the mark is ~1.8:1
    function lipsHtml(cls, badge) {
      return '<div class="lips ' + cls + '"><img src="' + LIPS + '" alt="">' + (badge ? '<span class="lips__n">' + badge + '</span>' : '') + '</div>';
    }
    var cluster = (L.markerClusterGroup ? L.markerClusterGroup({
      showCoverageOnHover: false, maxClusterRadius: 46,
      iconCreateFunction: function (c) {
        var n = c.getChildCount(), w = n < 10 ? PW + 10 : n < 50 ? PW + 18 : PW + 26, h = Math.round(w * 0.56);
        return L.divIcon({ html: lipsHtml('lips--cluster', n), className: '', iconSize: [w, h] });
      }
    }) : L.layerGroup());
    function icon(s, on) {
      return L.divIcon({ html: lipsHtml('lips--' + (s.type === 'drink' ? 'drink' : 'buy') + (on ? ' lips--on' : '')), className: '', iconSize: [PW, PH], popupAnchor: [0, -Math.round(PH / 2) - 2] });
    }
    var markers = {};
    all.forEach(function (s) {
      var maps = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(s.addr || s.name);
      var m = L.marker([s.lat, s.lng], { icon: icon(s, false), title: s.name }).bindPopup(
        '<b>' + esc(s.name) + '</b>' +
        '<span class="pin__kind">' + (s.type === 'drink' ? 'bar / restaurant' : 'store') + '</span><br>' +
        (s.addr ? esc(s.addr) + '<br>' : '') + (s.tel ? esc(s.tel) + '<br>' : '') +
        (s.url ? '<a href="' + esc(s.url) + '" target="_blank" rel="noopener">website</a> &middot; ' : '') +
        '<a href="' + maps + '" target="_blank" rel="noopener">directions &rarr;</a>');
      markers[s.id] = m;
    });
    map.addLayer(cluster);

    // type filter (all / stores / bars & restaurants)
    var type = 'all';
    function byType(rows) { return type === 'all' ? rows : rows.filter(function (s) { return (s.type || 'buy') === type; }); }
    function syncMarkers() {
      cluster.clearLayers();
      byType(all).forEach(function (s) { cluster.addLayer(markers[s.id]); });
    }
    syncMarkers();
    $$('[data-loc-type]').forEach(function (b) {
      b.addEventListener('click', function () {
        type = b.getAttribute('data-loc-type');
        $$('[data-loc-type]').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        syncMarkers(); apply();
        var rows = byType(all);
        if (rows.length) map.fitBounds(L.latLngBounds(rows.map(function (s) { return [s.lat, s.lng]; })).pad(0.1), { maxZoom: 12 });
      });
    });

    var ca = all.filter(function (s) { return s.state === 'CA'; });
    if (ca.length) map.fitBounds(L.latLngBounds(ca.map(function (s) { return [s.lat, s.lng]; })).pad(0.08));
    else if (all.length) map.fitBounds(L.latLngBounds(all.map(function (s) { return [s.lat, s.lng]; })).pad(0.1));

    var current = null;
    function focus(s) {
      var m = markers[s.id]; if (!m) return;
      if (current && markers[current]) markers[current].setIcon(icon(all.filter(function (x) { return x.id === current; })[0], false));
      current = s.id; m.setIcon(icon(s, true));
      if (cluster.zoomToShowLayer) cluster.zoomToShowLayer(m, function () { m.openPopup(); });
      else { map.setView(m.getLatLng(), 13); m.openPopup(); }
      $$('.hit', list).forEach(function (el) { el.setAttribute('aria-current', el.getAttribute('data-id') === s.id ? 'true' : 'false'); });
    }
    var emptyType = $('#locEmptyType');
    function renderList(rows) {
      var pool = byType(all);
      count.textContent = rows.length + ' of ' + pool.length + (type === 'drink' ? ' bars & restaurants' : type === 'buy' ? ' stores' : ' stockists');
      var noneOfType = pool.length === 0;
      if (emptyType) emptyType.hidden = !noneOfType;
      empty.hidden = rows.length > 0 || noneOfType;
      list.innerHTML = rows.map(function (s) {
        var d = typeof s._mi === 'number' ? ' &middot; ' + s._mi.toFixed(1) + ' mi' : '';
        var badge = s.type === 'drink' ? ' &middot; bar / restaurant' : '';
        return '<button class="hit" type="button" data-id="' + esc(s.id) + '" aria-current="false"><b>' + esc(s.name) + '</b>' +
               '<span>' + esc([s.city, s.state].filter(Boolean).join(', ')) + d + badge + '</span></button>';
      }).join('');
      $$('.hit', list).forEach(function (el) {
        el.addEventListener('click', function () {
          var s = all.filter(function (x) { return x.id === el.getAttribute('data-id'); })[0];
          if (s) focus(s);
        });
      });
    }
    var here = null, hereMarker = null;
    function miles(a, b, c, d) {
      var R = 3958.8, t = Math.PI / 180, dLat = (c - a) * t, dLon = (d - b) * t;
      var s1 = Math.sin(dLat / 2), s2 = Math.sin(dLon / 2);
      var h = s1 * s1 + Math.cos(a * t) * Math.cos(c * t) * s2 * s2;
      return 2 * R * Math.asin(Math.sqrt(h));
    }
    function withDistance(rows) {
      if (!here) return rows;
      return rows.map(function (s) { return Object.assign({}, s, { _mi: miles(here.lat, here.lng, s.lat, s.lng) }); })
                 .sort(function (x, y) { return x._mi - y._mi; });
    }
    function apply() {
      var v = q.value.trim().toLowerCase();
      var pool = byType(all);
      var rows = !v ? pool : pool.filter(function (s) { return [s.name, s.city, s.state, s.zip, s.addr].join(' ').toLowerCase().indexOf(v) !== -1; });
      renderList(withDistance(rows));
      if (v && rows.length) map.fitBounds(L.latLngBounds(rows.map(function (s) { return [s.lat, s.lng]; })).pad(0.2), { maxZoom: 13 });
      else if (!v && apply.lastV && pool.length) map.fitBounds(L.latLngBounds(pool.map(function (s) { return [s.lat, s.lng]; })).pad(0.1), { maxZoom: 12 });  // cleared: zoom back out
      apply.lastV = v;
    }
    gpsBtn.addEventListener('click', function () {
      if (!navigator.geolocation) { gpsBtn.textContent = 'location not supported'; return; }
      gpsBtn.textContent = 'locating…';
      navigator.geolocation.getCurrentPosition(function (pos) {
        here = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        gpsBtn.textContent = 'nearest to me';
        if (hereMarker) map.removeLayer(hereMarker);
        hereMarker = L.circleMarker([here.lat, here.lng], { radius: 8, color: '#fff', weight: 3, fillColor: '#E9B645', fillOpacity: 1 }).addTo(map).bindPopup('You are here');
        q.value = ''; apply();
        var near = withDistance(byType(all)).slice(0, 8);
        if (near.length) map.fitBounds(L.latLngBounds([[here.lat, here.lng]].concat(near.map(function (s) { return [s.lat, s.lng]; }))).pad(0.2), { maxZoom: 12 });
      }, function () {
        gpsBtn.textContent = 'location unavailable';
        setTimeout(function () { gpsBtn.textContent = 'use my location'; }, 2400);
      }, { enableHighAccuracy: false, timeout: 8000, maximumAge: 300000 });
    });
    q.addEventListener('input', apply);
    apply();
  }

  /* ---------------- vendor request form (become a vendor popup) ---------------- */
  function initVendorForm() {
    var vr = $('#vrForm'); if (!vr) return;
    var drop = $('#vrDrop'), doc = $('#vrDoc'), docName = $('#vrDocName'), vrErr = $('#vrErr'), vrBtn = $('#vrSubmit');
    function showFile() {
      var f = doc.files && doc.files[0];
      if (f) { docName.textContent = f.name + ' (' + Math.round(f.size / 1024) + ' KB)'; docName.hidden = false; drop.classList.add('has-file'); }
      else { docName.hidden = true; drop.classList.remove('has-file'); }
    }
    doc.addEventListener('change', showFile);
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
    drop.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) { doc.files = e.dataTransfer.files; showFile(); } });
    var same = $('#vrSame'), deliv = $('#vrDelivFields');
    if (same && deliv) same.addEventListener('change', function () { deliv.hidden = same.checked; });

    // type of business (Julio, 2026-10-21): the category list follows the type
    var vrType = $('#vrType'), vrCat = $('#vrCat');
    function syncType() {
      if (!vrType) return;
      var t = vrType.value;
      $('#vrCatField').hidden = !t;
      vrCat.querySelectorAll('optgroup').forEach(function (g) { var on = g.getAttribute('data-type') === t; g.hidden = !on; g.disabled = !on; });
      var sel = vrCat.selectedOptions[0];
      if (sel && sel.parentNode.tagName === 'OPTGROUP' && sel.parentNode.getAttribute('data-type') !== t) vrCat.value = '';
    }
    if (vrType) { vrType.addEventListener('change', syncType); syncType(); }

    // Where they distribute and through whom (Julio, 2026-10-21). MUST match
    // MARKETS in bh-brand-sites src/lib/amigosMarkets.ts. Any other state is
    // "coming soon": the store can still register, but signs no payment terms.
    var MARKETS = { CA: 'Supreme Spirits', NV: 'High Limits Spirits' };
    function storeState() { return $('#vrState').value.trim().toUpperCase(); }
    function comingSoon() { var st = storeState(); return !!st && !MARKETS[st]; }

    // payment terms (Julio, 2026-10-13): the distributor follows the store's
    // state; "credit" opens the terms + guarantor
    var hasTerms = !!$('#vrCod');
    function choice(name) { var c = vr.querySelector('input[name="' + name + '"]:checked'); return c ? c.value : ''; }
    function syncTerms() {
      var st = storeState(), soon = $('#vrSoon');
      if (soon) {
        soon.hidden = !comingSoon();
        var opt = $('#vrState').selectedOptions[0];
        soon.querySelectorAll('[data-state-name]').forEach(function (s) { s.textContent = opt && opt.value ? opt.textContent.trim() : 'your state'; });
      }
      if (!hasTerms) return;
      var dist = MARKETS[st] || '';
      // no state yet → a hint; a "coming soon" state → no terms at all
      var box = $('#vrTerms'); box.hidden = box.disabled = !dist;
      $('#vrTermsWait').hidden = !!st;
      if (!dist) return;
      vr.querySelectorAll('[data-dist]').forEach(function (s) { s.textContent = dist; });
      var credit = choice('payment_choice') === 'credit';
      $('#vrCreditBox').hidden = !credit; $('#vrGuarBox').hidden = !credit;
      $('#vrOtherField').hidden = !(credit && choice('credit_terms') === 'other');
    }
    if (hasTerms) {
      var today = new Date().toLocaleDateString('en-US');
      vr.querySelectorAll('[data-today]').forEach(function (s) { s.textContent = today; });
      vr.addEventListener('change', syncTerms);
      // the representative is usually the person filling in the form
      var rep = $('#vrRep');
      rep.addEventListener('focus', function () { if (!rep.value.trim()) rep.value = ($('#vrFirst').value.trim() + ' ' + $('#vrLast').value.trim()).trim(); });
    }
    $('#vrState').addEventListener('change', syncTerms);
    $('#vrState').addEventListener('input', syncTerms);
    syncTerms();
    vr.addEventListener('submit', function (e) {
      e.preventDefault(); vrErr.textContent = '';
      var req = ['vrFirst', 'vrLast', 'vrEmail', 'vrPhone', 'vrBiz', 'vrLic', 'vrStore', 'vrCity', 'vrState', 'vrZip'].filter(function (id) { return !$('#' + id).value.trim(); });
      var same = $('#vrSame');
      if (same && !same.checked) req = req.concat(['vrDeliv', 'vrDCity', 'vrDState', 'vrDZip'].filter(function (id) { return !$('#' + id).value.trim(); }));
      if (req.length) { vrErr.textContent = 'Please fill in every required field.'; $('#' + req[0]).focus(); return; }
      if (!/^\S+@\S+\.\S+$/.test($('#vrEmail').value.trim())) { vrErr.textContent = 'That email address does not look right.'; $('#vrEmail').focus(); return; }
      if (($('#vrPhone').value.match(/\d/g) || []).length < 7) { vrErr.textContent = 'Please enter a phone number we can reach you on.'; $('#vrPhone').focus(); return; }
      if (vrType && !vrType.value) { vrErr.textContent = 'Please choose your type of business.'; vrType.focus(); return; }
      if (vrType && !vrCat.value) { vrErr.textContent = 'Please choose your business category.'; vrCat.focus(); return; }
      if (hasTerms && !comingSoon()) {
        var pc = choice('payment_choice');
        if (!pc) { vrErr.textContent = 'Please choose COD / Prepaid or Credit Terms.'; $('#vrCod').focus(); return; }
        if (pc === 'credit') {
          var ct = choice('credit_terms');
          if (!ct) { vrErr.textContent = 'Please choose the credit terms you are requesting.'; vr.querySelector('input[name="credit_terms"]').focus(); return; }
          if (ct === 'other' && !$('#vrOther').value.trim()) { vrErr.textContent = 'Please tell us the credit terms you are requesting.'; $('#vrOther').focus(); return; }
        }
        var treq = ['vrRep', 'vrTitle', 'vrSig'];
        if (pc === 'credit') treq = treq.concat(['vrGName', 'vrGStreet', 'vrGCity', 'vrGState', 'vrGZip', 'vrGSig']);
        treq = treq.filter(function (id) { return !$('#' + id).value.trim(); });
        if (treq.length) { vrErr.textContent = pc === 'credit' ? 'Please complete the signature and guarantor fields — a guarantor is required when requesting credit terms.' : 'Please complete the signature fields.'; $('#' + treq[0]).focus(); return; }
        if (!$('#vrAgree').checked) { vrErr.textContent = 'Please check the box to sign the payment terms.'; $('#vrAgree').focus(); return; }
      }
      var f = doc.files && doc.files[0];
      if (f && f.size > 4 * 1024 * 1024) { vrErr.textContent = 'The document is over 4MB \u2014 please send a smaller file or a photo.'; return; }
      vrBtn.disabled = true; vrBtn.textContent = 'sending\u2026';
      fetch(vr.getAttribute('action'), { method: 'POST', body: new FormData(vr), mode: 'cors' })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || !res.j.success) throw new Error(res.j.error || 'Something went wrong. Please try again.');
          vr.hidden = true; $('#vrDone').hidden = false;
          var soonDone = res.j.market === 'coming_soon' && $('#vrDoneSoon');
          if (soonDone) { soonDone.hidden = false; $('#vrDoneMsg').hidden = true; }
          // the heading was the call to action; once sent, only the confirmation should show
          var ttl = document.querySelector('#wholesale .pop__title'); if (ttl) ttl.hidden = true;
        })
        .catch(function (ex) { vrErr.textContent = ex.message || 'Something went wrong. Please try again.'; })
        .then(function () { vrBtn.disabled = false; vrBtn.textContent = 'submit request'; });
    });
  }

  /* ---------------- vendor portal ----------------
     Token lives in sessionStorage (closes with the tab). Every call sends it
     as a bearer header; a 401 means signed out or deactivated.
     Two tabs once signed in: "place an order" (default) and "materials".
     The order math below MIRRORS src/lib/vendorOrders.ts in bh-brand-sites
     for the live total only — the API recomputes every order from the
     database and is the only number that counts. Money is in integer cents. */
  function initVendorPortal() {
    var root = document.querySelector('.vp'); if (!root) return;
    var API = (root.getAttribute('data-api') || '').replace(/\/$/, '');
    var KEY = 'at_vendor_token';
    var login = $('#vpLogin'), lib = $('#vpLib'), list = $('#vpList'), empty = $('#vpEmpty'), who = $('#vpWho'), err = $('#vpErr'), btn = $('#vpSubmit');
    function token(v) { try { if (v === undefined) return sessionStorage.getItem(KEY); if (v === null) sessionStorage.removeItem(KEY); else sessionStorage.setItem(KEY, v); } catch (e) { return null; } }
    function show(inLib) { login.hidden = inLib; lib.hidden = !inLib; if (!inLib) { var b = $('#voBar'); if (b) b.hidden = true; } }
    function signedOut(msg) { token(null); show(false); if (msg) err.textContent = msg; }
    function authed(url, opts) {
      opts = opts || {}; opts.headers = opts.headers || {}; opts.headers.Authorization = 'Bearer ' + token();
      return fetch(API + url, opts).then(function (r) {
        if (r.status === 401) { signedOut('Your session ended. Please sign in again.'); return null; }
        return r.json().catch(function () { return {}; }).then(function (j) { j.__ok = r.ok; return j; });
      });
    }
    function kb(n) { return n > 1048576 ? (n / 1048576).toFixed(1) + ' MB' : Math.round(n / 1024) + ' KB'; }
    var CAT = { 'price-sheets': 'price sheets', marketing: 'marketing', 'product-info': 'product info', forms: 'forms', general: 'general' };
    var ICON = { pdf: 'PDF', xlsx: 'XLS', xls: 'XLS', csv: 'CSV', docx: 'DOC', doc: 'DOC', pptx: 'PPT', png: 'IMG', jpg: 'IMG', jpeg: 'IMG', webp: 'IMG', zip: 'ZIP', mp4: 'VID', mov: 'VID' };

    /* ---- tabs ---- */
    var tabOrder = $('#vpTabOrder'), tabHist = $('#vpTabHist'), tabLib = $('#vpTabLib'), tabAcct = $('#vpTabAcct'), panOrder = $('#vpOrder'), panHist = $('#vpHistory'), panLib = $('#vpMaterials'), panAcct = $('#vpAccount');
    function tab(which) {
      var w = which === 'materials' || which === 'account' || which === 'orders' ? which : 'order';
      tabOrder.setAttribute('aria-selected', w === 'order'); tabHist.setAttribute('aria-selected', w === 'orders'); tabLib.setAttribute('aria-selected', w === 'materials'); tabAcct.setAttribute('aria-selected', w === 'account');
      panOrder.hidden = w !== 'order'; panHist.hidden = w !== 'orders'; panLib.hidden = w !== 'materials'; panAcct.hidden = w !== 'account';
      if (w === 'account') Account.load();
      if (w === 'orders') MyOrders.load();
      Order.bar();
    }
    tabOrder.addEventListener('click', function () { tab('order'); history.replaceState(null, '', '#order'); });
    tabHist.addEventListener('click', function () { tab('orders'); history.replaceState(null, '', '#orders'); });
    tabLib.addEventListener('click', function () { tab('materials'); history.replaceState(null, '', '#materials'); });
    tabAcct.addEventListener('click', function () { tab('account'); history.replaceState(null, '', '#account'); });
    $$('[data-go-account]').forEach(function (b) { b.addEventListener('click', function () { tab('account'); history.replaceState(null, '', '#account'); window.scrollTo({ top: panAcct.getBoundingClientRect().top + window.pageYOffset - 140, behavior: 'smooth' }); }); });

    /* ---- materials ---- */
    function loadMaterials() {
      return authed('/api/vendor-portal/materials').then(function (j) {
        if (!j) return false;
        if (!j.__ok) { empty.hidden = false; empty.textContent = j.error || "Could not load the materials."; return true; }
        who.textContent = (j.vendor.businessName || j.vendor.email).toLowerCase();
        var groups = {}; (j.materials || []).forEach(function (m) { (groups[m.category] = groups[m.category] || []).push(m); });
        var cats = Object.keys(groups);
        empty.hidden = cats.length > 0;
        // price sheets / product info first — that is what a vendor comes for
        var ORDER = ['price-sheets', 'product-info', 'marketing', 'forms', 'general'];
        cats.sort(function (a, b) { return (ORDER.indexOf(a) + 1 || 99) - (ORDER.indexOf(b) + 1 || 99); });
        var norm = function (s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); };
        list.innerHTML = cats.map(function (c) {
          return '<div class="vp__group"><p class="mono vp__cat">' + esc(CAT[c] || c) + '</p><div class="vp__files">' + groups[c].map(function (m) {
            var ext = (m.file_name.split('.').pop() || '').toLowerCase();
            var label = ICON[ext] || ext.toUpperCase().slice(0, 3);
            // staff often type the title again as the description — only show it when it adds something
            var words = function (x) { return String(x || '').toLowerCase().match(/[a-z0-9.]+/g) || []; };
            var tw = words(m.title), dw = words(m.description);
            var showDesc = dw.length > 0 && norm(m.title).indexOf(norm(m.description)) === -1 && !dw.every(function (w) { return tw.indexOf(w) !== -1; });
            return '<button class="vp__file" type="button" data-id="' + m.id + '" aria-label="Download ' + esc(m.title) + '">' +
              '<span class="vp__thumb' + (m.thumb_url ? '' : ' vp__thumb--doc') + '">' +
                (m.thumb_url ? '<img src="' + esc(m.thumb_url) + '" alt="" loading="lazy" decoding="async">' :
                  // no preview image → draw a document page with its file type on a tag
                  '<span class="vp__doc vp__doc--' + esc(label.toLowerCase()) + '" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i><span class="vp__ext">' + esc(label) + '</span></span>') +
              '</span>' +
              '<span class="vp__meta"><b>' + esc(m.title) + '</b>' + (showDesc ? '<span>' + esc(m.description) + '</span>' : '') +
              '<span class="vp__size">' + esc(ext.toUpperCase()) + (m.file_size ? ' &middot; ' + kb(m.file_size) : '') + '</span></span>' +
              '<span class="btn btn--ink btn--sm vp__dl">download</span></button>';
          }).join('') + '</div></div>';
        }).join('');
        return true;
      });
    }

    /* ---- order form ---- */
    var Order = (function () {
      var form = $('#voForm'), groupsEl = $('#voGroups'), loading = $('#voLoading'), done = $('#voDone'), bar = $('#voBar');
      var products = [], groups = [], qty = {}, submitKey = '', sending = false, loaded = false;
      function usd(c) { return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
      function cents(v) { return Math.round(Number(v) * 100); }
      function newKey() { var s = ''; for (var i = 0; i < 4; i++) s += Math.random().toString(36).slice(2, 10); return s; }
      function img(sku) { return panOrder.getAttribute('data-img-' + sku) || ''; }
      function plural(n, w) { return n + ' ' + w + (n === 1 ? '' : 's'); }

      /* same rules as the API (src/lib/vendorOrders.ts groupRules/effectiveMin):
         every group empty or at its minimum, at least one case. A group with
         requires_group (Gran) needs requires_cases of that group with it, and
         while it is in the order that group's own minimum drops to that number. */
      function other(g) { return groups.filter(function (x) { return x.group_key === g.requires_group; })[0]; }
      function deps(g, by) { return groups.filter(function (h) { return h.requires_group === g.group_key && (by[h.group_key] || 0) > 0; }); }
      function needWith(h, g) { return h.requires_cases != null ? h.requires_cases : g.min_cases; }
      function effMin(g, by) {
        var d = deps(g, by); if (!d.length) return g.min_cases;
        return Math.max.apply(null, d.map(function (h) { return needWith(h, g); }));
      }
      function depLabels(g, by) { return deps(g, by).map(function (h) { return h.label; }).join(' and '); }
      function compute() {
        var r = { lines: [], cases: 0, cans: 0, sub: 0, crv: 0, byGroup: {}, problems: [], bad: false };
        products.forEach(function (p) {
          if (p.sold_out) return; // never counted, whatever the box holds
          var raw = qty[p.id], n = Number(raw);
          if (raw === '' || raw == null || n === 0) return;
          if (!(n % 1 === 0) || n < 0 || n > 9999) { r.bad = true; r.problems.push('Enter a whole number of cases for ' + p.name + '.'); return; }
          var lineSub = cents(p.case_price) * n, lineCrv = cents(p.crv_per_can) * p.cans_per_case * n;
          r.lines.push({ p: p, n: n, sub: lineSub, crv: lineCrv });
          r.cases += n; r.cans += n * p.cans_per_case; r.sub += lineSub; r.crv += lineCrv;
          r.byGroup[p.group_key] = (r.byGroup[p.group_key] || 0) + n;
        });
        var by = r.byGroup;
        groups.forEach(function (g) {
          var have = by[g.group_key] || 0;
          if (!have) return;
          var min = effMin(g, by);
          if (have < min) r.problems.push(g.label + ': add ' + plural(min - have, 'more case') + ' to reach the ' + min + '-case minimum' + (min !== g.min_cases ? ' that comes with ' + depLabels(g, by) : '') + '.');
          var o = g.requires_group && other(g);
          if (o && !(by[o.group_key] || 0)) r.problems.push(g.label + ' must be ordered with at least ' + plural(needWith(g, o), 'case') + ' of ' + o.label + '.');
        });
        if (!r.lines.length && !r.bad) r.problems.unshift('Enter the number of cases you want to order.');
        return r;
      }

      function ruleText(g, rows) {
        var t = (rows.length > 1 ? 'Mix &amp; match any of these &mdash; ' : '') + 'minimum order <b>' + g.min_cases + ' cases</b>' + (rows.length > 1 ? ' combined' : '');
        var o = g.requires_group && other(g);
        if (o) t += ', plus at least <b>' + plural(needWith(g, o), 'case') + '</b> of ' + esc(o.label);
        groups.forEach(function (h) {
          if (h.requires_group === g.group_key && h.requires_cases != null && h.requires_cases !== g.min_cases) t += ' &mdash; or just <b>' + plural(h.requires_cases, 'case') + '</b> with an ' + esc(h.label) + ' order';
        });
        return t + '.';
      }

      function render() {
        groupsEl.innerHTML = groups.map(function (g) {
          var rows = products.filter(function (p) { return p.group_key === g.group_key; });
          return '<section class="vo__group" data-group="' + esc(g.group_key) + '">' +
            '<div class="vo__ghead"><h3 class="vo__gtitle">' + esc(g.label) + '</h3>' +
            '<p class="vo__rule">' + ruleText(g, rows) + '</p>' +
            '<div class="vo__meter" aria-hidden="true"><span></span></div>' +
            '<p class="vo__msg" role="status" aria-live="polite"></p></div>' +
            rows.map(function (p) {
              var pic = img(p.sku), so = !!p.sold_out, dis = so ? ' disabled' : '';
              // sold out: still listed (vendors see it exists), but the case box is locked
              return '<div class="vo__row' + (so ? ' is-soldout' : '') + '" data-id="' + p.id + '">' +
                '<div class="vo__pic vo__pic--' + esc(p.sku) + '">' + (pic ? '<img src="' + esc(pic) + '" alt="" loading="lazy" width="80" height="96">' : '<span>' + esc(g.group_key === 'gran' ? '19.2oz' : '12oz') + '</span>') + '</div>' +
                '<div class="vo__info"><b>' + esc(p.name) + (so ? ' <span class="vo__soldout">sold out</span>' : '') + '</b><span>' + esc(p.detail || '') + '</span>' +
                '<span class="vo__price">' + usd(cents(p.case_price)) + ' / case <em>+ CRV ' + usd(cents(p.crv_per_can) * p.cans_per_case) + '</em></span></div>' +
                '<div class="vo__qty"><button type="button" class="vo__step" data-step="-1" aria-label="One case fewer of ' + esc(p.name) + '"' + dis + '>&minus;</button>' +
                '<input type="number" inputmode="numeric" min="0" max="9999" step="1" value="" placeholder="0" aria-label="Cases of ' + esc(p.name) + (so ? ' (sold out)' : '') + '" data-qty="' + p.id + '"' + dis + '>' +
                '<button type="button" class="vo__step" data-step="1" aria-label="One case more of ' + esc(p.name) + '"' + dis + '>+</button></div>' +
                '<div class="vo__line" data-line="' + p.id + '"></div>' +
              '</div>';
            }).join('') +
          '</section>';
        }).join('');
        update();
      }

      /* the on-screen minimum messages live here: one per group, plus the summary list */
      function update() {
        var r = compute(), by = r.byGroup;
        groups.forEach(function (g) {
          var el = groupsEl.querySelector('[data-group="' + g.group_key + '"]'); if (!el) return;
          var have = by[g.group_key] || 0, msg = el.querySelector('.vo__msg'), meter = el.querySelector('.vo__meter span');
          var min = effMin(g, by), lowered = min !== g.min_cases;
          var state = !have ? 'idle' : have < min ? 'short' : 'ok';
          meter.style.width = Math.min(100, Math.round(have / min * 100)) + '%';
          if (state === 'short') msg.textContent = have + ' of ' + min + ' cases — add ' + plural(min - have, 'more case') + ' to meet the minimum' + (lowered ? ' with ' + depLabels(g, by) : '') + '.';
          else if (state === 'ok') msg.textContent = '✓ Minimum met — ' + plural(have, 'case') + (lowered && have < g.min_cases ? ' with ' + depLabels(g, by) : '') + '.';
          else if (lowered) { state = 'short'; msg.textContent = 'Add at least ' + plural(min, 'case') + ' — required with ' + depLabels(g, by) + '.'; }
          else msg.textContent = '';
          var o = g.requires_group && other(g);
          if (o && have && !(by[o.group_key] || 0)) { state = 'short'; msg.textContent += ' Also add at least ' + plural(needWith(g, o), 'case') + ' of ' + o.label + '.'; }
          el.setAttribute('data-state', state);
        });
        products.forEach(function (p) {
          var cell = groupsEl.querySelector('[data-line="' + p.id + '"]'); if (!cell) return;
          var l = r.lines.filter(function (x) { return x.p.id === p.id; })[0];
          cell.textContent = l ? usd(l.sub) : '';
          var row = cell.parentNode; row.classList.toggle('is-on', !!l);
        });
        $('#voLines').innerHTML = r.lines.length ? r.lines.map(function (l) {
          return '<li><span>' + l.n + ' &times; ' + esc(l.p.name) + '</span><span>' + usd(l.sub) + '</span></li>';
        }).join('') : '<li class="vo__none">No cases yet.</li>';
        $('#voCases').textContent = r.cases ? '(' + plural(r.cases, 'case') + ')' : '';
        $('#voCans').textContent = r.cans ? '(' + r.cans.toLocaleString('en-US') + ' cans × ' + usd(products.length ? cents(products[0].crv_per_can) : 5) + ')' : '';
        $('#voSub').textContent = usd(r.sub); $('#voCrv').textContent = usd(r.crv); $('#voTotal').textContent = usd(r.sub + r.crv);
        // the very first prompt is obvious from the form itself; only list real problems
        var shownProblems = r.lines.length || r.bad ? r.problems : [];
        $('#voProblems').innerHTML = shownProblems.map(function (p) { return '<li>' + esc(p) + '</li>'; }).join('');
        $('#voSubmit').disabled = sending || r.problems.length > 0;
        $('#voBarTotal').textContent = usd(r.sub + r.crv);
        $('#voBarNote').textContent = !r.lines.length ? 'add cases to start' : r.problems.length ? 'minimum not met yet' : 'ready to submit';
        bar.setAttribute('data-ready', r.lines.length && !r.problems.length ? '1' : '0');
        return r;
      }

      groupsEl.addEventListener('input', function (e) {
        var id = e.target.getAttribute('data-qty'); if (!id) return;
        qty[id] = e.target.value.trim(); $('#voErr').textContent = ''; update();
      });
      groupsEl.addEventListener('click', function (e) {
        var b = e.target.closest('.vo__step'); if (!b) return;
        var input = b.parentNode.querySelector('input'), id = input.getAttribute('data-qty');
        var n = Math.max(0, Math.min(9999, (parseInt(input.value, 10) || 0) + Number(b.getAttribute('data-step'))));
        input.value = n || ''; qty[id] = input.value; $('#voErr').textContent = ''; update();
      });
      // whole cases only: a typed "10.5" or "-3" is flagged by update(); this just stops the wheel nudging values
      groupsEl.addEventListener('wheel', function (e) { if (e.target.matches('input[type="number"]') && document.activeElement === e.target) e.target.blur(); }, { passive: true });

      form.addEventListener('submit', function (e) {
        e.preventDefault(); if (sending) return;
        var r = update(), errEl = $('#voErr'); errEl.textContent = '';
        if (r.problems.length) { errEl.textContent = r.problems[0]; return; }
        var oneTime = $('#voLoc').value === 'other';
        if ($('#voLoc').value === 'new') { errEl.textContent = 'Save your new delivery location first (or pick a saved one).'; $('#voNewStreet').focus(); return; }
        var need = [['#voName', 'your contact name'], ['#voPhone', 'a phone number']].concat(oneTime ? [['#voAddr', 'the delivery address']] : []);
        for (var i = 0; i < need.length; i++) {
          var f = $(need[i][0]);
          if (!f.value.trim()) { errEl.textContent = 'Please add ' + need[i][1] + '.'; f.setAttribute('aria-invalid', 'true'); f.focus(); return; }
          f.removeAttribute('aria-invalid');
        }
        if (($('#voPhone').value.match(/\d/g) || []).length < 7) { errEl.textContent = 'That phone number does not look right.'; $('#voPhone').focus(); return; }
        var quantities = {}; r.lines.forEach(function (l) { quantities[l.p.id] = l.n; });
        sending = true; var sb = $('#voSubmit'); sb.disabled = true; sb.textContent = 'sending…';
        authed('/api/vendor-portal/orders', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            quantities: quantities, submit_key: submitKey,
            contact_name: $('#voName').value, contact_phone: $('#voPhone').value,
            location_id: oneTime ? null : $('#voLoc').value, delivery_address: oneTime ? $('#voAddr').value : '',
            requested_date: $('#voDate').value, po_number: $('#voPo').value, notes: $('#voNotes').value
          })
        }).then(function (j) {
          if (!j) return;
          if (!j.__ok || !j.success) { errEl.textContent = j.error || 'Could not place your order. Please try again.'; return; }
          form.hidden = true; bar.hidden = true; done.hidden = false; $('#voNote').hidden = true;
          MyOrders.stale(); // the new order shows next time "my orders" opens
          $('#voRef').textContent = j.reference;
          $('#voDoneText').innerHTML = 'Thanks &mdash; your order for <b>' + plural(r.cases, 'case') + '</b> (' + usd(cents(j.total)) + ' incl. CRV) is with our fulfillment team. A confirmation is on its way to <b>' + esc($('#voEmail').textContent) + '</b>. Quote <b>' + esc(j.reference) + '</b> if you contact us about it.';
          window.scrollTo({ top: panOrder.getBoundingClientRect().top + window.pageYOffset - 120, behavior: 'smooth' });
        }).catch(function () {
          errEl.textContent = 'Could not reach the server. Check your connection and try again — your order was not sent twice.';
        }).then(function () { sending = false; sb.textContent = 'submit order'; update(); });
      });

      $('#voAgain').addEventListener('click', function () {
        qty = {}; submitKey = newKey(); $('#voPo').value = ''; $('#voNotes').value = ''; $('#voDate').value = ''; $('#voNote').hidden = true;
        done.hidden = true; form.hidden = false; render(); bar.hidden = false;
      });

      function load() {
        if (loaded) return Promise.resolve(true);
        return authed('/api/vendor-portal/order-form').then(function (j) {
          if (!j) return false;
          if (!j.__ok) { loading.textContent = j.error || 'The order form is not available right now.'; return true; }
          products = j.products || []; groups = j.groups || []; loaded = true; submitKey = newKey();
          var pf = j.prefill || {};
          $('#voName').value = pf.contact_name || ''; $('#voPhone').value = pf.contact_phone || '';
          // no saved locations yet → start on "another address" with what the application gave us
          $('#voAddr').value = (j.locations || []).length ? '' : (pf.delivery_address || '');
          setLocations(j.locations || []);
          $('#voEmail').textContent = pf.contact_email || '';
          if (pf.business_name || pf.contact_email) who.textContent = (pf.business_name || pf.contact_email).toLowerCase();
          var t = new Date(); $('#voDate').min = t.getFullYear() + '-' + ('0' + (t.getMonth() + 1)).slice(-2) + '-' + ('0' + t.getDate()).slice(-2);
          loading.hidden = true; form.hidden = false;
          render(); showBar();
          return true;
        });
      }
      var locs = [];
      function setLocations(list) {
        locs = list || []; var sel = $('#voLoc'), prev = sel.value;
        // every new address is saved to the account (2026-10-05): no more "this order only" address
        sel.innerHTML = locs.map(function (l) { return '<option value="' + l.id + '">' + esc(l.label) + (l.is_default ? ' (default)' : '') + '</option>'; }).join('') +
          '<option value="new">+ Add a new location…</option>';
        var keep = prev && prev !== 'other' && [].some.call(sel.options, function (o) { return o.value === prev; });
        sel.value = keep ? prev : (locs.length ? String(locs[0].id) : 'new');
        syncLoc();
      }
      var lastLoc = '';
      function syncLoc() {
        var v = $('#voLoc').value, l = locs.filter(function (x) { return String(x.id) === v; })[0];
        $('#voAddr').hidden = true;
        $('#voLocAddr').hidden = !l; $('#voLocAddr').textContent = l ? l.address.split(String.fromCharCode(10)).slice(1).join(', ') : '';
        var nw = $('#voNew'), opening = v === 'new' && nw.hidden;
        nw.hidden = v !== 'new';
        $('#voNewCancel').hidden = !locs.length; // nothing to go back to
        if (opening) { ['#voNewStreet', '#voNewStreet2', '#voNewCity', '#voNewState', '#voNewZip', '#voNewLabel'].forEach(function (s) { $(s).value = ''; }); $('#voNewErr').textContent = ''; }
        if (v !== 'new') lastLoc = v;
      }
      $('#voLoc').addEventListener('change', function () { syncLoc(); if ($('#voLoc').value === 'new') $('#voNewStreet').focus(); });

      /* add a delivery location without leaving the order: saved to the account
         (same API as my account), then picked as "Deliver To". */
      function saveNewLoc() {
        var err = $('#voNewErr'), b = $('#voNewSave'); err.textContent = '';
        var v = function (s) { return $(s).value.trim(); };
        var body = { action: 'add', street: v('#voNewStreet'), street2: v('#voNewStreet2'), city: v('#voNewCity'), state: v('#voNewState'), zip: v('#voNewZip') };
        body.label = v('#voNewLabel') || body.street;
        if (!body.street || !body.city || !body.state || !body.zip) { err.textContent = 'Please fill in the street, city, state and ZIP.'; return; }
        b.disabled = true; b.textContent = 'saving…';
        authed('/api/vendor-portal/locations', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
          .then(function (j) {
            if (!j) return;
            if (!j.__ok || !j.success) { err.textContent = j.error || 'Could not save the location.'; return; }
            // reload the account's locations (this refills the dropdown), then deliver to the new one
            return Account.load(true).then(function () {
              var sel = $('#voLoc');
              if ([].some.call(sel.options, function (o) { return o.value === String(j.id); })) sel.value = String(j.id);
              syncLoc();
            });
          })
          .catch(function () { err.textContent = 'Could not reach the server. Please try again.'; })
          .then(function () { b.disabled = false; b.textContent = 'save & deliver here'; });
      }
      $('#voNewSave').addEventListener('click', saveNewLoc);
      $('#voNewCancel').addEventListener('click', function () { $('#voLoc').value = lastLoc || ($('#voLoc').options[0] || {}).value; syncLoc(); });
      // these boxes sit inside the order form: Enter saves the location, never submits the order
      $('#voNew').addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' || e.defaultPrevented) return;
        e.preventDefault(); saveNewLoc();
      });
      function setContact(name, phone) { if (name != null) $('#voName').value = name; if (phone != null) $('#voPhone').value = phone; }
      function reset() { loaded = false; qty = {}; form.hidden = true; done.hidden = true; loading.hidden = false; loading.textContent = 'loading the order form…'; groupsEl.innerHTML = ''; bar.hidden = true; }
      // phones only, while the order tab is showing and the form (not the summary) is on screen
      var sumInView = false;
      function showBar() { bar.hidden = !(loaded && !panOrder.hidden && !form.hidden && !lib.hidden && !sumInView); }
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { sumInView = es[0].isIntersecting; showBar(); }).observe($('#voSum'));
      // "reorder" from my orders: copy an old order's cases in. Sold-out or
      // discontinued products are skipped and named, so nothing slips through.
      function setQuantities(byProduct, ref) {
        var skipped = [], copied = 0;
        qty = {}; done.hidden = true; form.hidden = false; submitKey = newKey();
        render();
        Object.keys(byProduct).forEach(function (pid) {
          var p = products.filter(function (x) { return String(x.id) === String(pid); })[0];
          if (!p || p.sold_out) { skipped.push(byProduct[pid].name); return; }
          qty[p.id] = String(byProduct[pid].cases); copied++;
          var input = groupsEl.querySelector('[data-qty="' + p.id + '"]'); if (input) input.value = qty[p.id];
        });
        update();
        var note = $('#voNote');
        note.textContent = (copied ? 'Cases copied from ' + ref + ' — check them, then submit.' : 'Nothing from ' + ref + ' can be ordered right now.') +
          (skipped.length ? ' Not available right now: ' + skipped.join(', ') + '.' : '');
        note.hidden = false;
      }
      return { load: load, reset: reset, bar: showBar, setLocations: setLocations, setContact: setContact, setQuantities: setQuantities };
    })();

    /* ---- my account: details, login email, delivery locations ----
       Vendors keep these up to date themselves (Julio, 2026-10-04). The login
       email changes only after a confirm link sent to the NEW address is
       clicked. Locations feed the order form's "Deliver To" dropdown. */
    var Account = (function () {
      var loaded = false, locs = [], editing = null;
      var NL = String.fromCharCode(10);
      function fmt(l) { return [l.label, [l.street, l.street2].filter(Boolean).join(', '), l.city + ', ' + l.state + ' ' + l.zip].join(NL); }
      function send(url, body) {
        return authed(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      }
      function pushToOrder() {
        Order.setLocations(locs.map(function (l) { return { id: l.id, label: l.label, is_default: l.is_default, address: fmt(l) }; }));
      }
      function fill(j) {
        var p = j.profile || {};
        $('#vaBiz').value = p.business_name || ''; $('#vaDba').value = p.dba_name || '';
        $('#vaContact').value = p.contact_name || ''; $('#vaPhone').value = p.phone || '';
        $('#vaLic').textContent = p.license_number || '—';
        $('#vaEmailNow').textContent = p.email || '';
        var pend = $('#vaEmailPending');
        pend.hidden = !p.pending_email;
        pend.textContent = p.pending_email ? 'Waiting for you to confirm ' + p.pending_email + ' — check that inbox for the link.' : '';
        locs = j.locations || []; renderLocs(); pushToOrder();
      }
      function load(force) {
        if (loaded && !force) return Promise.resolve();
        return authed('/api/vendor-portal/account').then(function (j) {
          if (!j) return;
          if (!j.__ok) { $('#vaLoading').textContent = j.error || 'Your account could not be loaded. Please try again.'; return; }
          loaded = true; fill(j); $('#vaLoading').hidden = true; $('#vaBody').hidden = false;
        });
      }
      function renderLocs() {
        var ul = $('#vaLocs');
        if (!locs.length) { ul.innerHTML = '<li class="va__none">No locations yet — add the address you want orders delivered to.</li>'; return; }
        ul.innerHTML = locs.map(function (l) {
          return '<li class="va__loc" data-id="' + l.id + '">' +
            '<div class="va__locmain"><b>' + esc(l.label) + (l.is_default ? ' <span class="va__default">default</span>' : '') + '</b>' +
            '<span>' + esc([l.street, l.street2].filter(Boolean).join(', ')) + ', ' + esc(l.city) + ', ' + esc(l.state) + ' ' + esc(l.zip) + '</span>' +
            ((l.phone || l.delivery_notes) ? '<span class="va__locmeta">' + esc([l.phone, l.delivery_notes].filter(Boolean).join(' · ')) + '</span>' : '') + '</div>' +
            '<div class="va__locbtns">' +
              '<button type="button" class="vp__link" data-loc="edit">edit</button>' +
              (l.is_default ? '' : '<button type="button" class="vp__link" data-loc="default">make default</button>') +
              (locs.length > 1 ? '<button type="button" class="vp__link va__danger" data-loc="remove">remove</button>' : '') +
            '</div></li>';
        }).join('');
      }
      var F = { label: '#vaLocLabel', street: '#vaLocStreet', street2: '#vaLocStreet2', city: '#vaLocCity', state: '#vaLocState', zip: '#vaLocZip', phone: '#vaLocPhone', delivery_notes: '#vaLocNotes' };
      function openForm(l) {
        editing = l ? l.id : null;
        Object.keys(F).forEach(function (k) { $(F[k]).value = l ? (l[k] || '') : ''; });
        $('#vaLocFormHead').textContent = l ? 'edit ' + l.label : 'new location';
        $('#vaLocErr').textContent = ''; $('#vaLocForm').hidden = false; $('#vaLocLabel').focus();
      }
      function closeForm() { editing = null; $('#vaLocForm').hidden = true; }

      $('#vaLocAdd').addEventListener('click', function () { openForm(null); });
      $('#vaLocCancel').addEventListener('click', closeForm);
      $('#vaLocForm').addEventListener('submit', function (e) {
        e.preventDefault(); var err = $('#vaLocErr'), b = $('#vaLocSave'); err.textContent = '';
        var body = { action: editing ? 'update' : 'add' }; if (editing) body.id = editing;
        Object.keys(F).forEach(function (k) { body[k] = $(F[k]).value.trim(); });
        if (!body.label || !body.street || !body.city || !body.state || !body.zip) { err.textContent = 'Please fill in the name, street, city, state and ZIP.'; return; }
        busy(b, true);
        send('/api/vendor-portal/locations', body).then(function (j) {
          if (!j) return;
          if (!j.__ok) { err.textContent = j.error || 'Could not save the location.'; return; }
          closeForm(); load(true);
        }).catch(function () { err.textContent = 'Could not reach the server. Please try again.'; })
          .then(function () { busy(b, false, 'save location'); });
      });
      $('#vaLocs').addEventListener('click', function (e) {
        var btn = e.target.closest('[data-loc]'); if (!btn) return;
        var id = Number(btn.closest('.va__loc').getAttribute('data-id')), l = locs.filter(function (x) { return x.id === id; })[0], act = btn.getAttribute('data-loc');
        var err = $('#vaLocsErr'); err.textContent = '';
        if (act === 'edit') { openForm(l); return; }
        if (act === 'remove' && !window.confirm('Remove ' + l.label + '? Past orders keep their address.')) return;
        send('/api/vendor-portal/locations', { action: act, id: id }).then(function (j) {
          if (!j) return;
          if (!j.__ok) { err.textContent = j.error || 'Could not update the location.'; return; }
          load(true);
        }).catch(function () { err.textContent = 'Could not reach the server. Please try again.'; });
      });

      $('#vaDetails').addEventListener('submit', function (e) {
        e.preventDefault(); var err = $('#vaDetailsErr'), ok = $('#vaDetailsOk'), b = $('#vaDetailsSave'); err.textContent = ''; ok.hidden = true;
        var body = { business_name: $('#vaBiz').value.trim(), dba_name: $('#vaDba').value.trim(), contact_name: $('#vaContact').value.trim(), phone: $('#vaPhone').value.trim() };
        if (!body.business_name) { err.textContent = 'Business name is required.'; $('#vaBiz').focus(); return; }
        if ((body.phone.match(/\d/g) || []).length < 7) { err.textContent = 'Please enter a phone number we can reach you on.'; $('#vaPhone').focus(); return; }
        busy(b, true);
        send('/api/vendor-portal/account', body).then(function (j) {
          if (!j) return;
          if (!j.__ok) { err.textContent = j.error || 'Could not save your details.'; return; }
          ok.hidden = false; who.textContent = body.business_name.toLowerCase();
          Order.setContact(body.contact_name, body.phone);
        }).catch(function () { err.textContent = 'Could not reach the server. Please try again.'; })
          .then(function () { busy(b, false, 'save details'); });
      });

      $('#vaEmail').addEventListener('submit', function (e) {
        e.preventDefault(); var err = $('#vaEmailErr'), b = $('#vaEmailSave'); err.textContent = '';
        var ne = $('#vaNewEmail').value.trim(), pw = $('#vaEmailPw').value;
        if (!/^\S+@\S+\.\S+$/.test(ne)) { err.textContent = 'Enter the new email address.'; $('#vaNewEmail').focus(); return; }
        if (!pw) { err.textContent = 'Enter your current password.'; $('#vaEmailPw').focus(); return; }
        busy(b, true);
        send('/api/vendor-portal/email', { new_email: ne, password: pw }).then(function (j) {
          if (!j) return;
          if (!j.__ok) { err.textContent = j.error || 'Could not start the email change.'; return; }
          $('#vaNewEmail').value = ''; $('#vaEmailPw').value = '';
          var pend = $('#vaEmailPending'); pend.hidden = false;
          pend.textContent = 'Check ' + j.pending_email + ' for a confirm link. Until you click it, keep signing in with your current email.';
        }).catch(function () { err.textContent = 'Could not reach the server. Please try again.'; })
          .then(function () { busy(b, false, 'send confirm link'); });
      });

      function reset() { loaded = false; locs = []; closeForm(); $('#vaBody').hidden = true; $('#vaLoading').hidden = false; $('#vaLoading').textContent = 'loading your account…'; }
      return { load: load, reset: reset };
    })();

    // a confirm-email link lands here with #confirm-email=<token>: swap the login email
    var ce = (location.hash.match(/[#&]confirm-email=([^&]+)/) || [])[1];
    if (ce) {
      try { history.replaceState(null, '', location.pathname + location.search); } catch (e) { /* keep going */ }
      var note = $('#vpNotice');
      fetch(API + '/api/vendor-portal/email', { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token: decodeURIComponent(ce) }) })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { j.__ok = r.ok; return j; }); })
        .then(function (j) {
          note.hidden = false;
          if (j.__ok) { note.textContent = '✓ Your login email is now ' + j.email + '. Use it next time you sign in.'; note.classList.remove('is-err'); $('#vpEmail').value = j.email; }
          else { note.textContent = j.error || 'That confirm link did not work.'; note.classList.add('is-err'); }
        })
        .catch(function () { note.hidden = false; note.classList.add('is-err'); note.textContent = 'Could not reach the server. Please open the link again.'; });
    }

    /* ---- my orders: the vendor's own order history ----
       Status is what Amigos staff set by hand in the admin (Received /
       In progress / Completed) — the portal is not connected to their
       fulfillment system, so it is shown with the date staff last changed it.
       "reorder" copies an order's cases into a new order to review + submit. */
    var MyOrders = (function () {
      var loaded = false, orders = [], open = {};
      var NL = String.fromCharCode(10);
      function usdV(v) { return '$' + Number(v).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
      function day(iso) { return iso ? new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : ''; }
      function ymd(s) { if (!s) return ''; var p = s.split('-'); return new Date(Date.UTC(+p[0], +p[1] - 1, +p[2])).toLocaleDateString('en-US', { timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' }); }
      function statusCls(s) { return s === 'Completed' ? 'is-done' : s === 'In progress' ? 'is-prog' : 'is-new'; }
      function render() {
        var ul = $('#vhList');
        $('#vhEmpty').hidden = orders.length > 0; $('#vhIntro').hidden = !orders.length;
        ul.innerHTML = orders.map(function (o) {
          var isOpen = !!open[o.id];
          var where = o.location_label || (o.delivery_address || '').split(NL)[0];
          return '<li class="vh__order' + (isOpen ? ' is-open' : '') + '" data-id="' + o.id + '">' +
            '<button type="button" class="vh__sum" aria-expanded="' + isOpen + '">' +
              '<span class="vh__ref">' + esc(o.reference) + '</span>' +
              '<span class="vh__date">' + esc(day(o.created_at)) + '</span>' +
              '<span class="vh__where">' + esc(where) + '</span>' +
              '<span class="vh__fig">' + o.total_cases + ' cases · <b>' + usdV(o.total) + '</b></span>' +
              '<span class="vh__status ' + statusCls(o.status) + '">' + esc(o.status) + (o.status_updated_at && o.status !== 'Received' ? ' · ' + esc(day(o.status_updated_at)) : '') + '</span>' +
              '<span class="vh__chev" aria-hidden="true">' + (isOpen ? '▾' : '▸') + '</span>' +
            '</button>' +
            (isOpen ? '<div class="vh__body">' +
              '<table class="vh__items"><thead><tr><th>Product</th><th class="num">Cases</th><th class="num">Amount</th></tr></thead><tbody>' +
                o.items.map(function (i) { return '<tr><td>' + esc(i.name) + '<small>' + usdV(i.case_price) + ' / case</small></td><td class="num">' + i.cases + '</td><td class="num">' + usdV(i.line_subtotal) + '</td></tr>'; }).join('') +
              '</tbody><tfoot>' +
                '<tr><td colspan="2">Subtotal (' + o.total_cases + ' cases)</td><td class="num">' + usdV(o.subtotal) + '</td></tr>' +
                '<tr><td colspan="2">CRV (' + Number(o.total_cans).toLocaleString('en-US') + ' cans)</td><td class="num">' + usdV(o.crv_total) + '</td></tr>' +
                '<tr class="vh__total"><td colspan="2">Order total</td><td class="num">' + usdV(o.total) + '</td></tr>' +
              '</tfoot></table>' +
              '<dl class="vh__kv">' +
                '<dt>Deliver to</dt><dd>' + esc(o.delivery_address || '—').split(NL).join('<br>') + '</dd>' +
                (o.requested_date ? '<dt>Requested date</dt><dd>' + esc(ymd(o.requested_date)) + '</dd>' : '') +
                (o.po_number ? '<dt>PO number</dt><dd>' + esc(o.po_number) + '</dd>' : '') +
                (o.notes ? '<dt>Notes</dt><dd>' + esc(o.notes).split(NL).join('<br>') + '</dd>' : '') +
                '<dt>Status</dt><dd>' + esc(o.status) + (o.status_updated_at && o.status !== 'Received' ? ' (updated ' + esc(day(o.status_updated_at)) + ')' : '') + '</dd>' +
              '</dl>' +
              '<button type="button" class="btn btn--red btn--sm vh__reorder" data-reorder="' + o.id + '">reorder these cases</button>' +
            '</div>' : '') +
          '</li>';
        }).join('');
      }
      function load(force) {
        if (loaded && !force) return;
        $('#vhLoading').hidden = false;
        authed('/api/vendor-portal/orders').then(function (j) {
          if (!j) return;
          if (!j.__ok) { $('#vhLoading').textContent = j.error || 'Your orders could not be loaded. Please try again.'; return; }
          loaded = true; orders = j.orders || []; $('#vhLoading').hidden = true; render();
        });
      }
      $('#vhList').addEventListener('click', function (e) {
        var re = e.target.closest('[data-reorder]');
        if (re) {
          var o = orders.filter(function (x) { return String(x.id) === re.getAttribute('data-reorder'); })[0]; if (!o) return;
          var by = {}; o.items.forEach(function (i) { if (i.product_id) by[i.product_id] = { cases: i.cases, name: i.name }; });
          Order.setQuantities(by, o.reference);
          tab('order'); history.replaceState(null, '', '#order');
          window.scrollTo({ top: panOrder.getBoundingClientRect().top + window.pageYOffset - 120, behavior: 'smooth' });
          return;
        }
        var sum = e.target.closest('.vh__sum'); if (!sum) return;
        var id = sum.closest('.vh__order').getAttribute('data-id'); open[id] = !open[id]; render();
      });
      return { load: load, stale: function () { loaded = false; }, reset: function () { loaded = false; orders = []; open = {}; $('#vhList').innerHTML = ''; $('#vhIntro').hidden = true; $('#vhEmpty').hidden = true; $('#vhLoading').hidden = false; $('#vhLoading').textContent = 'loading your orders…'; } };
    })();

    function enter() {
      show(true);
      var h = location.hash;
      tab(h === '#materials' ? 'materials' : h === '#account' ? 'account' : h === '#orders' ? 'orders' : 'order');
      return Promise.all([loadMaterials(), Order.load()]).then(function (ok) { if (ok[0] === false || ok[1] === false) return; });
    }
    function load() {
      if (!token()) { show(false); return; }
      enter().catch(function () { show(false); });
    }

    $('#vpForm').addEventListener('submit', function (e) {
      e.preventDefault(); err.textContent = '';
      var email = $('#vpEmail').value.trim(), pass = $('#vpPass').value;
      if (!email || !pass) { err.textContent = 'Enter your email and password.'; return; }
      btn.disabled = true; btn.textContent = 'signing in…';
      fetch(API + '/api/vendor-portal/login', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: email, password: pass }) })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || !res.j.token) throw new Error(res.j.error || 'Could not sign in.');
          token(res.j.token); $('#vpPass').value = ''; load();
        })
        .catch(function (ex) { err.textContent = ex.message || 'Could not sign in.'; })
        .then(function () { btn.disabled = false; btn.textContent = 'sign in'; });
    });
    $('#vpOut').addEventListener('click', function () { token(null); show(false); list.innerHTML = ''; Order.reset(); Account.reset(); MyOrders.reset(); var c = $('#vpChange'); if (c) { c.hidden = true; c.reset(); } var m = $('#vpChanged'); if (m) m.hidden = true; });
    list.addEventListener('click', function (e) {
      var f = e.target.closest('.vp__file'); if (!f) return;
      var dl = f.querySelector('.vp__dl'), was = dl.textContent; dl.textContent = 'preparing…';
      authed('/api/vendor-portal/download', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: f.getAttribute('data-id') }) })
        .then(function (j) { if (j && j.url) { window.location.href = j.url; } else if (j) { dl.textContent = j.error || 'unavailable'; } })
        .catch(function () { dl.textContent = 'try again'; })
        .then(function () { setTimeout(function () { dl.textContent = was; }, 1800); });
    });
    /* ---- self-service passwords (vendors manage their own) ----
       forgot → email link (#reset=<token>, a fragment: never sent to a server)
       → choose a new password → signed straight in. Change password while
       signed in. A password change signs out every other session, so both
       calls hand back a fresh token for this tab. */
    var forgotF = $('#vpForgot'), resetF = $('#vpReset'), changeF = $('#vpChange'), changedMsg = $('#vpChanged');
    var resetToken = null;
    function panel(which) { $('#vpForm').hidden = which !== 'login'; forgotF.hidden = which !== 'forgot'; resetF.hidden = which !== 'reset'; }
    function postJSON(url, body, auth) {
      var h = { 'Content-Type': 'application/json' }; if (auth) h.Authorization = 'Bearer ' + token();
      return fetch(API + url, { method: 'POST', headers: h, body: JSON.stringify(body) })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { j.__status = r.status; j.__ok = r.ok; return j; }); });
    }
    function busy(btn, on, label) { btn.disabled = on; btn.textContent = on ? 'one moment…' : label; }
    $('#vpForgotOpen').addEventListener('click', function () { $('#vpForgotEmail').value = $('#vpEmail').value; $('#vpForgotErr').textContent = ''; $('#vpForgotOk').hidden = true; panel('forgot'); $('#vpForgotEmail').focus(); });
    $$('[data-vp-back]').forEach(function (b) { b.addEventListener('click', function () { resetToken = null; panel('login'); }); });
    forgotF.addEventListener('submit', function (e) {
      e.preventDefault(); var errEl = $('#vpForgotErr'), ok = $('#vpForgotOk'), b = $('#vpForgotSubmit'); errEl.textContent = ''; ok.hidden = true;
      var email = $('#vpForgotEmail').value.trim();
      if (!/^\S+@\S+\.\S+$/.test(email)) { errEl.textContent = 'Enter the email address you sign in with.'; return; }
      busy(b, true);
      postJSON('/api/vendor-portal/forgot', { email: email }).then(function (j) {
        if (!j.__ok) { errEl.textContent = j.error || 'Something went wrong. Please try again.'; return; }
        ok.textContent = j.message; ok.hidden = false;
      }).catch(function () { errEl.textContent = 'Could not reach the server. Please try again.'; })
        .then(function () { busy(b, false, 'send reset link'); });
    });
    $('#vpShowNew').addEventListener('change', function (e) { var t = e.target.checked ? 'text' : 'password'; $('#vpNew').type = t; $('#vpNew2').type = t; });
    resetF.addEventListener('submit', function (e) {
      e.preventDefault(); var errEl = $('#vpResetErr'), b = $('#vpResetSubmit'); errEl.textContent = '';
      var p1 = $('#vpNew').value, p2 = $('#vpNew2').value;
      if (p1.length < 8) { errEl.textContent = 'Your password needs at least 8 characters.'; $('#vpNew').focus(); return; }
      if (p1 !== p2) { errEl.textContent = "The two passwords don't match."; $('#vpNew2').focus(); return; }
      busy(b, true);
      postJSON('/api/vendor-portal/reset', { token: resetToken, password: p1 }).then(function (j) {
        if (!j.__ok || !j.token) { errEl.textContent = j.error || 'Could not save your password. Please try again.'; return; }
        resetToken = null; $('#vpNew').value = ''; $('#vpNew2').value = '';
        token(j.token); panel('login'); load();
      }).catch(function () { errEl.textContent = 'Could not reach the server. Please try again.'; })
        .then(function () { busy(b, false, 'save & sign in'); });
    });
    $('#vpChangeOpen').addEventListener('click', function () { changeF.hidden = !changeF.hidden; changedMsg.hidden = true; $('#vpChangeErr').textContent = ''; if (!changeF.hidden) $('#vpCur').focus(); });
    $('#vpChangeCancel').addEventListener('click', function () { changeF.hidden = true; changeF.reset(); });
    changeF.addEventListener('submit', function (e) {
      e.preventDefault(); var errEl = $('#vpChangeErr'), b = $('#vpChangeSubmit'); errEl.textContent = '';
      var cur = $('#vpCur').value, p1 = $('#vpChg').value, p2 = $('#vpChg2').value;
      if (!cur) { errEl.textContent = 'Enter your current password.'; $('#vpCur').focus(); return; }
      if (p1.length < 8) { errEl.textContent = 'Your new password needs at least 8 characters.'; $('#vpChg').focus(); return; }
      if (p1 !== p2) { errEl.textContent = "The two new passwords don't match."; $('#vpChg2').focus(); return; }
      busy(b, true);
      postJSON('/api/vendor-portal/password', { current: cur, password: p1 }, true).then(function (j) {
        if (j.__status === 401) { signedOut('Your session ended. Please sign in again.'); return; }
        if (!j.__ok || !j.token) { errEl.textContent = j.error || 'Could not change your password. Please try again.'; return; }
        token(j.token); changeF.reset(); changeF.hidden = true; changedMsg.hidden = false;
      }).catch(function () { errEl.textContent = 'Could not reach the server. Please try again.'; })
        .then(function () { busy(b, false, 'save new password'); });
    });
    // a reset link lands here with #reset=<token>: show "choose a new password",
    // and wipe the token from the address bar right away
    var rt = (location.hash.match(/[#&]reset=([^&]+)/) || [])[1];
    if (rt) {
      resetToken = decodeURIComponent(rt);
      try { history.replaceState(null, '', location.pathname + location.search); } catch (e) { /* keep going */ }
      token(null); show(false); panel('reset');
    }

    // "vendor portal ↗" in the Amigos admin opens this page with #vt=<token>
    // (a fragment, never sent to a server): take the token, then wipe it from
    // the address bar and history so it is not shared or bookmarked.
    var vt = (location.hash.match(/[#&]vt=([^&]+)/) || [])[1];
    if (vt) {
      token(decodeURIComponent(vt));
      try { history.replaceState(null, '', location.pathname + location.search + '#order'); } catch (e) { location.hash = 'order'; }
    }
    load();
  }

  /* ---------------- address autocomplete ----------------
     Type "123 main…" or a store name in a Street box → Google suggests real
     addresses; tapping one fills street, suite, city, state and ZIP.
     Google Places API (New) called straight from the browser. The key is a
     browser key, locked in Google Cloud to the Amigos domains + Places API
     only (Birdhaus Google login, "My First Project"). Any failure (offline,
     key blocked, quota) just means no suggestions; typing by hand always works. */
  var PLACES_KEY = 'AIzaSyCtnKQa7XU1FYl7tQCwpP_CnzDQfY_M9vs';
  var addrUid = 0;
  function newSession() {
    try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) { /* fall through */ }
    return 'xxxxxxxx-xxxx-4xxx-8xxx-xxxxxxxxxxxx'.replace(/x/g, function () { return (Math.random() * 16 | 0).toString(16); });
  }
  function attachAddress(f) {
    var input = f.street;
    if (!input || input.getAttribute('data-addr-ac')) return;
    input.setAttribute('data-addr-ac', '1');
    // the browser's own saved-address popup would sit on top of ours
    input.setAttribute('autocomplete', 'off');
    var id = 'addrAc' + (++addrUid), session = newSession(), timer = null, seq = 0, items = [], active = -1;
    var wrap = input.parentNode; wrap.classList.add('addr-ac');
    var list = document.createElement('ul');
    list.className = 'addr-ac__list'; list.id = id; list.setAttribute('role', 'listbox'); list.hidden = true;
    wrap.appendChild(list);
    input.setAttribute('role', 'combobox'); input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', id); input.setAttribute('aria-expanded', 'false');

    function close() { list.hidden = true; items = []; active = -1; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); }
    function mark(i) {
      active = i;
      $$('.addr-ac__opt', list).forEach(function (li, n) { li.classList.toggle('is-active', n === i); li.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
      if (i >= 0) input.setAttribute('aria-activedescendant', id + '-' + i); else input.removeAttribute('aria-activedescendant');
    }
    function render() {
      if (!items.length) { close(); return; }
      list.innerHTML = items.map(function (s, i) {
        return '<li class="addr-ac__opt" role="option" id="' + id + '-' + i + '" data-i="' + i + '" aria-selected="false">' +
          '<b>' + esc(s.main) + '</b><span>' + esc(s.sub) + '</span></li>';
      }).join('') + '<li class="addr-ac__by" aria-hidden="true">powered by Google</li>';
      list.hidden = false; input.setAttribute('aria-expanded', 'true'); mark(-1);
    }
    function suggest() {
      var q = input.value.trim(), my = ++seq;
      if (q.length < 3) { close(); return; }
      fetch('https://places.googleapis.com/v1/places:autocomplete', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Goog-Api-Key': PLACES_KEY },
        body: JSON.stringify({
          input: q, sessionToken: session, includedRegionCodes: ['us'],
          includedPrimaryTypes: ['street_address', 'premise', 'subpremise', 'establishment'],
          // lean toward Southern California without hiding anywhere else
          locationBias: { circle: { center: { latitude: 33.9, longitude: -117.9 }, radius: 50000 } }
        })
      }).then(function (r) { return r.ok ? r.json() : {}; }).then(function (j) {
        if (my !== seq || document.activeElement !== input) return;
        items = (j.suggestions || []).filter(function (s) { return s.placePrediction; }).slice(0, 5).map(function (s) {
          var p = s.placePrediction, sf = p.structuredFormat || {};
          return { id: p.placeId, biz: (p.types || []).indexOf('establishment') !== -1, main: (sf.mainText && sf.mainText.text) || p.text.text, sub: ((sf.secondaryText && sf.secondaryText.text) || '').replace(/, USA$/, '') };
        });
        render();
      }).catch(close);
    }
    function set(el, v) {
      if (!el || v == null) return;
      el.value = v;
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    }
    function pick(i) {
      var s = items[i]; if (!s) return;
      close();
      var tok = session; session = newSession(); // one session = typing + the pick
      fetch('https://places.googleapis.com/v1/places/' + encodeURIComponent(s.id) + '?sessionToken=' + encodeURIComponent(tok), {
        headers: { 'X-Goog-Api-Key': PLACES_KEY, 'X-Goog-FieldMask': 'addressComponents' }
      }).then(function (r) { return r.ok ? r.json() : {}; }).then(function (j) {
        var c = {};
        (j.addressComponents || []).forEach(function (a) { (a.types || []).forEach(function (t) { if (!c[t]) c[t] = a; }); });
        var g = function (t, long) { return c[t] ? (long ? c[t].longText : c[t].shortText) : ''; };
        var street = [g('street_number'), g('route')].filter(Boolean).join(' ');
        if (!street) { set(input, s.main); return; }
        set(input, street);
        // picked a store by name → use it for an empty location-name box
        if (s.biz && f.label && !f.label.value.trim()) set(f.label, s.main);
        if (g('subpremise') && f.street2 && !f.street2.value.trim()) set(f.street2, g('subpremise'));
        set(f.city, g('locality', true) || g('sublocality', true) || g('postal_town', true) || g('neighborhood', true));
        set(f.state, g('administrative_area_level_1'));
        set(f.zip, g('postal_code'));
        (f.street2 || f.city || input).focus();
      }).catch(function () { set(input, s.main); });
    }

    input.addEventListener('input', function (e) {
      if (!e.isTrusted) return; // our own fills don't re-open the list
      clearTimeout(timer); timer = setTimeout(suggest, 220);
    });
    input.addEventListener('keydown', function (e) {
      if (list.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); mark(Math.min(active + 1, items.length - 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); mark(Math.max(active - 1, -1)); }
      else if (e.key === 'Enter' && active >= 0) { e.preventDefault(); pick(active); }
      else if (e.key === 'Escape') { close(); }
    });
    input.addEventListener('blur', function () { setTimeout(close, 150); });
    // mousedown (not click) so the pick lands before the input's blur closes the list
    list.addEventListener('mousedown', function (e) {
      var li = e.target.closest('.addr-ac__opt'); if (!li) return;
      e.preventDefault(); pick(Number(li.getAttribute('data-i')));
    });
  }
  function initAddressAuto() {
    var byId = function (x) { return document.getElementById(x); };
    [['vrStore', 'vrStore2', 'vrCity', 'vrState', 'vrZip'],
     ['vrDeliv', 'vrDeliv2', 'vrDCity', 'vrDState', 'vrDZip'],
     ['vaLocStreet', 'vaLocStreet2', 'vaLocCity', 'vaLocState', 'vaLocZip', 'vaLocLabel'],
     ['voNewStreet', 'voNewStreet2', 'voNewCity', 'voNewState', 'voNewZip', 'voNewLabel']].forEach(function (ids) {
      if (byId(ids[0])) attachAddress({ street: byId(ids[0]), street2: byId(ids[1]), city: byId(ids[2]), state: byId(ids[3]), zip: byId(ids[4]), label: ids[5] ? byId(ids[5]) : null });
    });
  }

  /* ---------------- boot ---------------- */
  function boot() {
    initGate(); initHeader(); initReveals(); initMobnav();
    Cart.init(); initPopups(); initNewsletter(); initRegister(); initProduct(); initLocator(); initVendorForm(); initVendorPortal(); initAddressAuto();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // theme editor: re-init the piece that was reloaded
  if (designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      initReveals(e.target);
      if (e.target.querySelector('#pdpForm')) initProduct();
      if (e.target.querySelector('#locMap')) initLocator();
      if (e.target.querySelector('#hdr')) { initHeader(); initMobnav(); }
    });
    document.addEventListener('shopify:block:select', function (e) { initReveals(e.target); });
  }
})();
